/* --- AGGRESSIVE GOOGLE TAG MANAGER (GTM) DEFERRAL --- */

// 1. Flag and Function Definition
window.gtmDidInit = false;

function initGTM() {
  if (window.gtmDidInit) {
    return;
  }
  window.gtmDidInit = true;

  // GTM Container Snippet - THIS MUST BE INSIDE THE FUNCTION
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-TD222PBL'); 

  // Optional: Add event to dataLayer to signify late loading
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({'event': 'gtm_deferred_loaded'});
}

// 2. Defines and attaches interaction listeners
const interactionEvents = ['scroll', 'mousemove', 'touchstart', 'keydown'];

function loadGTMOnInteraction(e) {
  initGTM();

  // Remove listeners after the first interaction
  interactionEvents.forEach(eventName => {
    document.removeEventListener(eventName, loadGTMOnInteraction, { passive: true });
  });
}

// Attach listeners
interactionEvents.forEach(eventName => {
  document.addEventListener(eventName, loadGTMOnInteraction, { passive: true });
});

// --- Your existing document.addEventListener('DOMContentLoaded', ...) block follows here ---

// **Your existing document.addEventListener('DOMContentLoaded', ...) block should follow this code.**
document.addEventListener('DOMContentLoaded', () => {

// --- Define Product Model Script Loading Function ---
  // This function is called by the Intersection Observer to load the product-model.js script.
  window.loadProductModelScript = (targetElement) => {
    // Check if the script has already been added to avoid duplicates.
    if (document.getElementById('product-model-script-loader')) {
      return;
    }

    const script = document.createElement('script');
    script.src = Shopify.assetUrl('product-model.js');
    script.id = 'product-model-script-loader';
    script.defer = true;
    
    // Once the script is loaded, initialize any models on the page.
    script.onload = function() {
      if (window.ProductModel && typeof window.ProductModel.loadAll === 'function') {
          window.ProductModel.loadAll();
      }
    };
    
    // Append the new script to the document body to start loading.
    document.body.appendChild(script);

    // Mark the element as loaded.
    targetElement.classList.add('loaded');
  };

  // The Intersection Observer setup should then follow this function. 
  // (It appears to start on Line 85 in your previous screenshot, which is correct for deferring scripts.)
  // --- Intersection Observer Setup (The Lazy-Loading Engine) ---
  const lazyLoadElements = document.querySelectorAll('.lazy-load-element[data-load-function]');


  if ('IntersectionObserver' in window && lazyLoadElements.length > 0) {
    const observerOptions = {
      rootMargin: '200px 0px', // Start loading 200px before the element enters the viewport
      threshold: 0.01 // Load when 1% of the element is visible
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('loaded')) {
          const targetElement = entry.target;
          const loadFunctionName = targetElement.dataset.loadFunction;

          // Check if the assigned loading function exists in the window scope.
          if (typeof window[loadFunctionName] === 'function') {
            window[loadFunctionName](targetElement);
            // Stop observing the element once it has been loaded
            observer.unobserve(targetElement);
          } else {
            console.error(`Lazy load function "${loadFunctionName}" not found.`);
          }
        }
      });
    }, observerOptions);

    // Start observing all elements marked for lazy loading
    lazyLoadElements.forEach(element => {
      observer.observe(element);
    });

  } else if (lazyLoadElements.length > 0) {
    // Fallback for browsers that don't support Intersection Observer (very rare)
    lazyLoadElements.forEach(element => {
      const loadFunctionName = element.dataset.loadFunction;
      if (typeof window[loadFunctionName] === 'function') {
        window[loadFunctionName](element);
      }
    });
  }
});
